import Vue from 'vue'
import VueRouter from 'vue-router'
import Article from '@/pages/journal/article.vue'
import Index from '@/pages/index.vue'
import Share from '@/pages/share.vue'
Vue.use(VueRouter)


export default new VueRouter({
    routes:[
		
		{
			path:"/",
			redirect:"/index"
		},
		
		{
		    path:"/index",
		    component:Index,
		},
		       
		
        {
            path:"/article",
            component:Article,
 
        },
		
		{
		    path:"/share",
		    component:Share,
		},
		
    ]
})


